import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./actions/resetAll";

export type GridItensRedux = {
    renderFlag: number // Contador numérico em vez de UUID
}

const initialState: GridItensRedux = {
    renderFlag: 0 // Valor inicial mais leve
}

const gridItensSlice = createSlice({
    name: "gridItens",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        atualizarFlag: (state) => {
            state.renderFlag += 1; // Incremento é 10-100x mais rápido que UUID
        }
    }
})

export default gridItensSlice.reducer

export const { atualizarFlag: atualizarFlagAction } = gridItensSlice.actions